import { BCMSDate, BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageData as getChatPageDefaultPageData, getDefaultPageUI as getChatPageDefaultPageUI } from "components/pages/ChatPage";
import FullScreenChatPage, { getDefaultPageUI as getFullScreenChatPageDefaultPageUI } from "components/pages/FullScreenChatPage";
import ChatLandingPage from "components/pages/ChatLandingPage";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";

export default function CaptureChatAgentResponse2(props) {
    const { branding } = useModel();
    const options = branding.options || {};
    const ui = BCMSStateManagerCRUD.init(getChatPageDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], false)        
        .submit();

    const date = BCMSDate.init();
    const response = ChatItem.init("Hi, there! How can I help you?", "received", date, 0, "Agent")
    const question = ChatItem.init("Hi! I'm looking for my profile information.", "sent", date, 5)
    const responseTwo = ChatItem.init("No problem! Let me help you find that.", "received", date, 10, "Agent")

    const data = BCMSStateManagerCRUD.init(getChatPageDefaultPageData())
        .update([ "messages" ], [ response, question, responseTwo ])
        .submit();

    return <ChatLandingPage ui={ ui } data={ data } />
}